
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cashback/fondsdepotbank",
      function () {
        return require("private-next-pages/cashback/fondsdepotbank.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cashback/fondsdepotbank"])
      });
    }
  